import { AxiosRequestHeaders } from 'axios';
import { ClientResponse } from '../../../model/ClientResponse';
import { Predpis } from '../../../model/indexer/Predpis';
import { indexerAxiosInstance } from '../../configuration/axiosConfig';
import { PredpisItem, PredpisResponse } from './model/PredpisResponse';

export const mapPredpisItem = (predpis: PredpisItem): Predpis => ({
  cislo: predpis.cislo,
  nazov: predpis.nazov,
});

export async function fetchPredpis(
  cislo: boolean,
  options: { headers?: AxiosRequestHeaders } = {},
): Promise<ClientResponse<Predpis>> {
  const {
    data: responseData,
    status,
  } = await indexerAxiosInstance.get<PredpisResponse>(
    `/vyhladavanie/predpisZbierky/rozsirene?cislo=${cislo}`,
    options,
  );

  return {
    data: responseData.docs.length === 0 ? null : mapPredpisItem(responseData.docs[0]),
    responseCode: status,
  };
}
